var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.row.Qty) + ": " + _vm._s(_vm.row.Sku) + " "),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.edit()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "pen" } })],
            1
          ),
          _c(
            "w-button",
            {
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.remove()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "trash" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(" " + _vm._s(_vm.row.Name) + " "),
              ]),
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(
                  " € " + _vm._s(_vm._f("humanFloat")(_vm.row.Total)) + " "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }